var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyEvent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 179,
    height: 102,
    viewBox: "0 0 179 102",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2225 15.4633L50.3678 17.3656C70.8043 22.1455 77.0474 32.2418 72.2675 52.6295L67.4876 73.0173C63.3906 90.6248 55.294 97.7459 40.0764 96.2827C37.6377 96.0876 35.0038 95.6486 32.1749 94.9658L23.9808 93.0148C3.64183 88.1861 -2.65008 78.1386 2.12982 57.7508L6.90972 37.3143C7.88521 33.1685 9.0558 29.5592 10.519 26.5839C16.2257 14.7805 25.9318 11.6102 42.2225 15.4633Z",
    fill: "url(#paint0_linear_191_1915)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2225 15.4633L50.3678 17.3656C70.8043 22.1455 77.0474 32.2418 72.2675 52.6295L67.4876 73.0173C63.3906 90.6248 55.294 97.7459 40.0764 96.2827C37.6377 96.0876 35.0038 95.6486 32.1749 94.9658L23.9808 93.0148C3.64183 88.1861 -2.65008 78.1386 2.12982 57.7508L6.90972 37.3143C7.88521 33.1685 9.0558 29.5592 10.519 26.5839C16.2257 14.7805 25.9318 11.6102 42.2225 15.4633Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M173.276 46.6951C172.55 45.9821 171.47 45.6912 170.477 45.9467L147.042 51.7525L150.632 35.056C151.926 29.033 148.078 23.0765 142.055 21.7815L54.2307 2.89928C48.2076 1.60433 42.2511 5.45276 40.9562 11.4758L30.205 61.481C28.9101 67.5041 32.7585 73.4606 38.7816 74.7555L126.606 93.6378C132.629 94.9327 138.585 91.0843 139.88 85.0613L143.47 68.3648L162.448 83.2895C162.826 83.576 163.222 83.7784 163.671 83.8747C164.203 83.9892 164.765 83.9635 165.308 83.7578C166.291 83.4122 167 82.5682 167.217 81.5596L174.113 49.4835C174.33 48.475 174.03 47.4141 173.276 46.6951ZM87.9679 59.5972C81.7208 58.2541 77.7404 52.0934 79.0835 45.8462C80.4267 39.5991 86.5874 35.6187 92.8346 36.9618C99.0817 38.305 103.062 44.4657 101.719 50.7128C100.376 56.96 94.2151 60.9404 87.9679 59.5972Z",
    fill: "url(#paint1_linear_191_1915)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.948 51.2245L97.5294 61.5948C94.914 63.6466 91.521 64.4289 88.2704 63.73C85.0198 63.0311 82.2484 60.9234 80.7064 57.9778L73.1173 43.4355C71.7558 40.841 71.427 37.8266 72.1938 34.9992C72.9618 32.171 74.7698 29.7379 77.2568 28.1881C79.9251 26.6145 83.1282 26.2269 86.0931 27.1183C89.0761 27.9909 91.5498 30.0865 92.9009 32.8853L94.4917 35.8954L96.7702 34.104C99.0325 32.2422 101.917 31.3073 104.841 31.4884C107.765 31.6708 110.512 32.954 112.526 35.0815C114.459 37.4337 115.359 40.4683 115.02 43.4937C114.776 46.519 113.305 49.3127 110.948 51.2245L110.948 51.2245Z",
    fill: "url(#paint2_linear_191_1915)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_191_1915",
    x1: 15.6462,
    y1: 13.9097,
    x2: 91.5096,
    y2: 89.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_191_1915",
    x1: 110.847,
    y1: 15.0719,
    x2: 143.089,
    y2: 87.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37645D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F5C53",
    stopOpacity: 0.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_191_1915",
    x1: 95.8137,
    y1: 29.1717,
    x2: 88.3786,
    y2: 63.7533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2C3BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvent);
export default __webpack_public_path__ + "static/media/emptyEvent.da51dbd028a8fd9d8055e715c3b4100e.svg";
export { ForwardRef as ReactComponent };